/* eslint-disable no-param-reassign,import/no-cycle */
import axios from 'axios';
import store from '../store';
import i18n from '../i18n/i18n-config';
import eventBus, { OPEN_SNACKBAR } from '../util/event-bus';

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT,
});

httpClient.interceptors.request.use((config) => {
  if (store.getters['auth/accessToken']) {
    config.headers.common.Authorization = `Bearer ${store.getters['auth/accessToken']}`;
  }
  if (store.getters['auth/impersonatingAs']) {
    config.headers.common['Impersonating-As'] = `${store.getters['auth/impersonatingAs']}`;
  }
  config.headers.common.Locale = store.state.settings.locale;
  // console.log(JSON.stringify(config.data, null, 2));
  return config;
});

httpClient.interceptors.response.use(
  (res) => res,
  (error) => {
    if (!error.response?.status) {
      return;
    }
    switch (error.response.status) {
      case 403:
      case 422:
      case 429:
        eventBus.$emit(OPEN_SNACKBAR, i18n.t(`http_errors.${error.response.status}`));
        throw error;
      case 500: {
        if (error.response.data.message && error.response.data.message.indexOf('login') > -1) {
          store.dispatch('auth/logout').catch(() => {});
        } else {
          eventBus.$emit(OPEN_SNACKBAR, i18n.t('http_errors.500'));
        }
        throw error;
      }
      default: {
        throw error;
      }
    }
  },
);

export default httpClient;
